// Root is 14px here, so rem values below 1 are what read as smaller than body text.
const wrapStyle = {
  fontSize: '0.85rem',
  lineHeight: 1.6,
  color: 'var(--color-gray-600, #6b7280)',
  marginTop: '0.4rem',
};

const codeStyle = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  fontSize: '0.95em',
  color: 'inherit',
  backgroundColor: 'transparent',
  padding: 0,
};

const summaryStyle = { cursor: 'pointer', display: 'inline', listStyle: 'none' };

const itemStyle = { whiteSpace: 'nowrap' };

const moreRowStyle = { marginTop: '0.3rem' };

const PRIMARY = [
  ['@', 'to mention'],
  ['__bold__', null],
  ['*italic*', null],
  ['[text](url)', null],
  ['- list', null],
];

const MORE = [
  ['1. numbered list', null],
  ['~~strikethrough~~', null],
  ['`code`', null],
  ['> quote', null],
  ['- [ ] checklist', null],
];

const Row = ({ items }) => (
  <>
    {items.map(([syntax, label], i) => (
      <span key={syntax} style={itemStyle}>
        {i > 0 && <span aria-hidden="true"> · </span>}
        <code style={codeStyle}>{syntax}</code>
        {label ? ` ${label}` : null}
      </span>
    ))}
  </>
);

export default function FormattingHint() {
  return (
    <div style={wrapStyle} data-testid="comment-formatting-hint">
      <Row items={PRIMARY} />
      <details style={moreRowStyle}>
        <summary style={summaryStyle}>More formatting</summary>
        <div style={moreRowStyle}>
          <Row items={MORE} />
        </div>
      </details>
    </div>
  );
}
